import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <div><img src="../assets/images/logo.png" height="45px"></div>
    <!--<div class="socials">
    <a href="https://www.twitter.com/TTNFLEET" target="_blank"><i class="fa fa-twitter" aria-hidden="true"></i></a>
    <a href="#" target="_blank"><i class="fa fa-linkedin" aria-hidden="true"></i></a>
    <a href="https://www.youtube.com/channel/UCHrx9kb7ug3ZFuWI6rYYxJQ" target="_blank"><i class="fa fa-youtube-play" aria-hidden="true"></i></a>
    </div>-->
  `,
})
export class FooterComponent {
}
